import { render, staticRenderFns } from "./VillageSales.vue?vue&type=template&id=b1af7898&scoped=true&"
import script from "./VillageSales.vue?vue&type=script&lang=js&"
export * from "./VillageSales.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1af7898",
  null
  
)

export default component.exports